import * as React from "react";
import * as _ from "lodash";
import { SidingType, typeNameMap, sentencize } from './colors';


export interface DropdownItemProperties extends React.Props<DropdownItemProperties> {
    type: SidingType;
    onClick: () => void;
}

export class SidingDropdownItem extends React.Component<DropdownItemProperties, {}> {
    render() {
        return (<li onClick={ this.props.onClick } data-type={SidingType[this.props.type]} >{ typeNameMap(this.props.type) }</li>);
    }
}

export interface IDropdownProperties extends React.Props<IDropdownProperties> {
    options: SidingType[];
    onItemSelected: (item: SidingType) => void;
    enabled: boolean;
    title?: string;
}

export interface IDropdownState {
    open: boolean;
    title: string;
}

export class Dropdown extends React.Component<IDropdownProperties, IDropdownState> {
    node = React.createRef<HTMLDivElement>();

    static defaultProps: IDropdownProperties = {
        options: [],
        enabled: false,
        title: "",
        onItemSelected: () => {}
    };

    constructor(props: IDropdownProperties) {
        super(props);
        this.state = {
            open: false,
            title: this.props.title || (this.props.options.length ? SidingType[this.props.options[0]] : "") || "Choose Siding"
        };
    }

    selectClicked(item: SidingType) {
        this.setState({
            open: false,
            title: typeNameMap(item)
        });
        this.props.onItemSelected(item);
    }

    handleClick() {
        this.setState(_.extend(this.state, { open: !this.state.open }) as IDropdownState);

        if (this.state.open) {
            document.addEventListener('click', (e) => this.handleOutsideClick(e), false);
          } else {
            document.removeEventListener('click', (e) => this.handleOutsideClick(e), false);
          }
    }

    handleOutsideClick(e: MouseEvent) {

        if(!this.node || !this.node.current) return;
        if(!e.target) return;


        // ignore clicks on the component itself
        if (this.node.current.contains(e.target as Node)) {
          return;
        }

        this.setState(_.extend(this.state, { open: false }) as IDropdownState);
    }

    render() {
        return (
            <div className={`type-dropdown ${this.props.options.length > 1 ? "has-items" : "no-items" } selected-${this.state.title}`} ref={this.node}>
                <div onClick={ e => { this.handleClick() }}>{ sentencize(this.state.title) }</div>
                <ul style={{ display: this.state.open && this.props.options.length > 1 ? "block" : "none" }}>
                    {this.props.options.map((item, i) => {
                        return (
                            <SidingDropdownItem onClick={this.selectClicked.bind(this, item)} type={item}></SidingDropdownItem>
                        );
                    }, this)}
                </ul>
            </div>
        );
    }
}